var React = require('react');

function IcErrorOutline24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0V0z","key":0}),React.createElement("path",{"d":"M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z","key":1})]);
}

IcErrorOutline24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcErrorOutline24px;

IcErrorOutline24px.default = IcErrorOutline24px;
